import { UserIsAuthenticated, UserHasValidPassword, UserHasRole } from 'containers/authContainers'
import { injectReducer } from 'store/reducers'
import { setSubroute } from 'store/navbar'
import { setPageTitle } from 'utils/misc'
import { USER_ROLES_CAN_ACCESS_DCF_TOOL } from 'utils/constants'
import CreateDCFContainer from './containers/CreateDCFContainer'
import reducer from './modules/CreateDCF'

export default store => ({
  path: 'create',
  exact: true,
  getComponent(nextState, cb) {
    require.ensure(
      [],
      () => {
        const { params } = nextState
        const { studyID } = params
        const state = store.getState()

        injectReducer(store, {
          key: 'createDcf',
          reducer,
        })

        store.dispatch(setSubroute('dataCorrectionV2'))
        setPageTitle(`New DCF | Study ${studyID} | ${state.study.currentStudy.platform_name}`)

        cb(
          null,
          UserIsAuthenticated(
            UserHasValidPassword(
              UserHasRole(USER_ROLES_CAN_ACCESS_DCF_TOOL, studyID, CreateDCFContainer),
            ),
          ),
        )
      },
      'data-correction-v2/create',
    )
  },
})
